import { useMutation } from '@tanstack/react-query';
import { MultipleRateGroupsUpdateParameters, useRepositoryRegistry } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';

export const useRateGroupUpdateMutation = ({ successAlert = true }: { successAlert?: boolean } = {}) => {
    const { rateGroups } = useRepositoryRegistry();

    return useMutation({
        mutationFn: async (parameters: MultipleRateGroupsUpdateParameters) => rateGroups.update(parameters),
        mutationKey: ['rateGroups', 'update'],
        ...(successAlert
            ? {
                  onSuccess: () => {
                      showSuccessAlert({ description: lt('SaveSuccessMessage') });
                  },
              }
            : {}),
    });
};
